export default ({ image, aspect = image.width / image.height, classes }) => {
  const sizes = [];

  for (let width = 30; width <= 2880; width += 30) {
    const height = width / aspect;

    if (image.width <= width) {
      break;
    }

    if (image.height <= height) {
      break;
    }

    sizes.push(width);
  }

  return `
  <img src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
     data-src="${Shopify.Image.getSizedImageUrl(image.src, '{width}x{height}_crop_center')}"
     data-aspectratio="${aspect}"
     data-sizes="auto"
     data-widths="[${sizes.join(',')}]"
     alt="${image.alt ?? ''}"
     class="${classes || ''} lazyload">
  `;
};
